import { c as _c } from "react/compiler-runtime";
import { getOrgRolesOptions } from '@onefootprint/fetch-dashboard';
import type { DashboardSecretApiKey } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DropdownSelector from '@/components/dropdown-selector';
import useUpdateRoleId from '../../hooks/use-update-role-id';
export type EditRoleProps = {
  apiKey: DashboardSecretApiKey;
};
const EditRole = t0 => {
  const $ = _c(20);
  const {
    apiKey
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "table.editRole"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("api-keys", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getOrgRolesOptions({
      query: {
        kind: "api_key"
      }
    });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data: roles
  } = useQuery(t2);
  const updateApiKeyMutation = useUpdateRoleId();
  let t3;
  if ($[2] !== apiKey.role.id || $[3] !== apiKey.role.name) {
    t3 = {
      id: apiKey.role.id,
      name: apiKey.role.name
    };
    $[2] = apiKey.role.id;
    $[3] = apiKey.role.name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const [value, setValue] = useState(t3);
  let t4;
  if ($[5] !== roles?.data) {
    t4 = roles?.data.map(_temp);
    $[5] = roles?.data;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const options = t4;
  let t5;
  if ($[7] !== apiKey.id || $[8] !== apiKey.role.id || $[9] !== apiKey.role.name || $[10] !== roles?.data || $[11] !== updateApiKeyMutation) {
    t5 = roleId => {
      const newRole = roles?.data.find(role_0 => role_0.id === roleId);
      if (newRole) {
        updateApiKeyMutation.mutate({
          path: {
            id: apiKey.id
          },
          body: {
            roleId: newRole.id
          }
        }, {
          onError: () => {
            setValue({
              id: apiKey.role.id,
              name: apiKey.role.name
            });
          }
        });
        setValue({
          id: newRole.id,
          name: newRole.name
        });
      }
    };
    $[7] = apiKey.id;
    $[8] = apiKey.role.id;
    $[9] = apiKey.role.name;
    $[10] = roles?.data;
    $[11] = updateApiKeyMutation;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleChange = t5;
  let t6;
  if ($[13] !== t) {
    t6 = t(_temp2);
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== handleChange || $[16] !== options || $[17] !== t6 || $[18] !== value) {
    t7 = <DropdownSelector options={options} triggerAriaLabel={t6} value={value} onValueChange={handleChange} />;
    $[15] = handleChange;
    $[16] = options;
    $[17] = t6;
    $[18] = value;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default EditRole;
function _temp(role) {
  return {
    id: role.id,
    name: role.name,
    customData: role.scopes
  };
}
function _temp2($) {
  return $.ariaLabel;
}